import React from 'react';

import SmsSubscriptionForm from './SmsSubscriptionForm';
import PropTypes from 'prop-types';

export default class SmsSubscriptionTrigger extends React.Component {
  static propTypes = {
    onSubmit: PropTypes.func.isRequired,
  };

  componentDidMount() {
    this.props.onLoad(this.props.phone);
    this.props.onLoad(this.props.phone_verification_id);
  }

  render() {
    const {
      hideSmsSubscriptionForm,
      isSubmitting,
      phone,
      phoneVerificationId,
      onSubmit,
      statusMessage,
      statusMessageError,
    } = this.props;
    const initialValues = {
      phone,
    };

    return (
      <div className="Message">
        <div
          className={
            statusMessage
              ? 'text SmsSubscriptionTrigger__status-message'
              : statusMessageError
              ? 'text red SmsSubscriptionTrigger__status-message'
              : 'hide'
          }
        >
          {statusMessage || statusMessageError}
        </div>
        <div className={hideSmsSubscriptionForm ? 'hide' : ''}>
          <h2 className="SmsSubscriptionTrigger__title heading--title--small">
            Get First Access To JUUL Offers
          </h2>
          <p className="Message__body SmsSubscriptionTrigger__description">
            Sign up for SMS alerts to get exclusive offers and news. Carrier
            message and data rates may apply.
          </p>
          <SmsSubscriptionForm
            isSubmitting={isSubmitting}
            initialValues={initialValues}
            onSubmit={onSubmit}
            phoneVerificationId={phoneVerificationId}
          />
        </div>
      </div>
    );
  }
}
